import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M21 12a9 9 0 10-18 0 9 9 0 0018 0zM2 12a10 10 0 1120 0 10 10 0 01-20 0z" /><path d="M18 11.07v4.25c0 .15-.23.28-.5.28-.28 0-.5-.13-.5-.28V8h1v3.07zm-1.37 5.98c-1.05.51-2.18.31-2.53-.45-.34-.76.22-1.8 1.27-2.31 1.05-.52 2.18-.32 2.53.44.34.77-.23 1.8-1.27 2.32zM6 9V8h9v1H6zm0 3v-1h9v1H6zm0 3v-1h6v1H6z" /></svg>);